import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

import styles from './Panel.module.scss';

class Panel extends Component {
  static propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    noHeader: PropTypes.bool,
  };

  static defaultProps = {
    title: '',
    subTitle: '',
  };

  state = {};

  render() {
    const {
      children,
      title,
      subTitle,
      noHeader,
      className,
    } = this.props;

    const mainClass = classNames(
      styles.main,
      className,
      { [styles['main--noHeader']]: noHeader }
    );

    return (
      <div className={mainClass}>
        {!noHeader && (
          <div className={styles.header}>
            {title}
            {subTitle && <span className={styles.subTitle}>{subTitle}</span>}
          </div>
        )}
        <div className={styles.content}>
          {children}
        </div>
      </div>
    );
  }
}

export default Panel;
